import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import ptBr from '@angular/common/locales/pt';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RecaptchaModule } from 'ng-recaptcha';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AutenticacaoModule } from './autenticacao/autenticacao.module';
import { CadastroModule } from './cadastro/cadastro.module';
import { CheckoutModule } from './checkout/checkout.module';
import { ContratoModule } from './contrato/contrato.module';
import { HomeModule } from './home/home.module';
import { AjudaClienteModalComponent } from './login/ajuda-cliente-modal/ajuda-cliente-modal.component';
import { LoginComponent } from './login/login.component';
import { MaterialAngularModule } from './material-design/material.module';
import { PasswordRecoveryModule } from './password-recovery/password-recovery.module';
import { PerfilModule } from './perfil/perfil.module';
import { RenegotiationResumeModule } from './renegotiation-resume/renegotiation-resume.module';
import { SecondCopyInstallmentModule } from './second-copy-installment/second-copy-installment.module';
import { CanDeactivateGuard } from './seguranca/can-deactivate.guard';
import { HttpAutenticacaoIntercept } from './seguranca/http-autenticacao-intercept.service';
import { HttpErrorInterceptService } from './seguranca/http-error-intercept.service';
import { SegurancaModule } from './seguranca/seguranca.module';
import { ComponentsModule } from './shared/components/components.module';
import { SharedDirectivesModule } from './shared/directives/shared-directives.module';
import { LayoutModule } from './shared/layout/layout.module';
import { LoaderModule } from './shared/loader/loader.module';
import { MensagensModule } from './shared/mensagens/mensagens.module';
import { FenixClientService } from './shared/services/fenix-client.service';
import { GoogleAnalyticsService } from './shared/services/google-analytics.service';
import { StepperOverviewModule } from './stepper-overview/stepper-overview.module';
import { ToastModule } from './shared/toast/toast.module';
import { PasswordRecoveryExternalModule } from './password-recovery-external/password-recovery-external.module';
import { RenegociacaoCartaoModule } from './renegociacao-cartao/renegociacao-cartao.module';
import { PasswordRecoveryService } from './shared/services/password-recovery.service';
import { ApiService } from './shared/api/api.service';

registerLocaleData(ptBr);

@NgModule({
  imports: [
    BrowserModule,
    RecaptchaModule,
    BrowserAnimationsModule,
    MaterialAngularModule,
    ReactiveFormsModule,
    FormsModule,
    FlexLayoutModule,
    HttpClientModule,
    MensagensModule,
    ContratoModule,
    AppRoutingModule,
    SegurancaModule,
    CadastroModule,
    AutenticacaoModule,
    PerfilModule,
    SharedDirectivesModule,
    ToastModule.forRoot(),
    PasswordRecoveryExternalModule,
    PasswordRecoveryModule,
    ComponentsModule,
    HomeModule,
    RenegociacaoCartaoModule,
    SecondCopyInstallmentModule,
    CheckoutModule,
    RenegotiationResumeModule,
    StepperOverviewModule,
    LayoutModule,
    LoaderModule
  ],
  declarations: [
    AppComponent,
    LoginComponent,
    AjudaClienteModalComponent
  ],
  providers: [
    GoogleAnalyticsService,
    FenixClientService,
    PasswordRecoveryService,
    ApiService,
    { provide: LOCALE_ID, useValue: 'pt' },
    { provide: HTTP_INTERCEPTORS, useClass: HttpAutenticacaoIntercept, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptService, multi: true },
    CanDeactivateGuard
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
